// Feature flag values must be camel-cased in React
// https://docs.launchdarkly.com/sdk/client-side/react/react-web#flag-keys
//
// NOTE: this does not apply when the flag is being used on the server side.
// (e.g. captcha, disable-rate-limit), because the server uses the nodejs
// server side library. We may want to maintain separate sets of flags for
// client-side and server- side usage.
export enum FEATURE_FLAGS {
  CAPTCHA_ADMIN = 'captchaAdmin',
  ADMIN_IMITATION = 'adminImitation',
  BSC = 'bscAddOns',
  CELO = 'celoAddOns',
  COINBASE_BETA = 'coinbaseBeta',
  CREDIT_PLAN_BANNER = 'creditPlanBanner',
  DISABLE_GROWTH_PLAN = 'disableGrowthPlan',
  GETTING_STARTED_TILE = 'gettingStartedTile',
  HIGH_BATCH_REQUEST_USERS = 'highBatchRequestUsers',
  IPFS_STATS = 'ipfsStats',
  LINEA = 'consensyszkevmAddOns',
  LINEA_FAUCET_RELEASE = 'lineaTestnetFaucet',
  LINEA_MAINTENANCE_MODE = 'lineaMaintenanceMode',
  MIGRATING_USERS_UKS_CAPPED = 'migratingUsersUksCapped',
  NO_EMAIL_ALIAS = 'noEmailAlias',
  PALM = 'palmNetwork',
  SEPOLIA_MAINTENANCE_MODE = 'sepoliaMaintenanceMode',
  STARKNET = 'starknetAddOns',
  TOKENS = 'tokens',
  UPDATES_2FA = '2FaUpdates',
  USE_PAYWALL = 'usePaywall',
  NEW_API_KEY_POLICY_ENABLED = 'newApiKeyPolicyEnabled',
  API_KEY_POLICY_VARIATION = 'apiKeyPolicyVariation',
  FAUCET_BYPASS_DOMAINS = 'faucetBypassDomains',
  METAMASK_LOGIN = 'metamaskLogin',
  SHOW_MEV_SETTINGS = 'showMevSettings',
  IPFS_SURVEY_BANNER = 'ipfsSurveyBanner',
  THROUGHPUT_ADDON = 'throughputAddon',
  BURSTABLE_THROUGHPUT_ADDON_BANNER = 'burstableThroughputAddonBanner',
  WEB3AUTH_LOGIN_AND_REGISTRATION = 'web3AuthLoginAndRegistration'
}
/* eslint-enable */
// feauture flags on the server should follow the exact format of the flag key on LD
export enum SERVER_FEATURE_FLAGS {
  CAPTCHA_ADMIN = 'captcha-admin',
  COINBASE_BETA = 'coinbaseBeta',
  DISABLE_GROWTH_PLAN = 'disable-growth-plan',
  FAUCET_ADMIN = 'Faucet-admin',
  FAUCET_MAINNET_MIN_BALANCE = 'faucet-mainnet-min-balance-enabled',
  LINEA = 'consensyszkevmAddOns',
  LINEA_MAINTENANCE_MODE = 'linea-maintenance-mode',
  MIGRATING_USERS_UKS_CAPPED = 'migrating-users-uks-capped',
  PAUSE_SUBSCRIPTION_UPDATED_EMAIL = 'pause-subscription-updated-email',
  SKIP_NONCE_CHECK = 'skip-nonce-check',
  SEPOLIA_MAINTENANCE_MODE = 'sepolia-maintenance-mode',
  FAUCET_BYPASS_DOMAINS = 'faucet-bypass-domains',
  METAMASK_LOGIN = 'metamaskLogin'
}
